const atleticoMg = [
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 26/27 - Uniforme 1",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2026",
      "atlético mineiro 2026",
      "atletico mg 2026",
      "atlético mg 2026",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/26-27-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01/galo4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 26/27 - Uniforme 1 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2026",
      "atlético mineiro 2026",
      "atletico mg 2026",
      "atlético mg 2026",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/26-27-01-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/26-27-01-f/galo4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme 01",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01/galo4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme 01 Edição Especial",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "atletico 2025",
      "atlético 2025",
      "2025",
      "atletico mineiro edição especial",
      "atlético mineiro edição especial",
      "atletico mg edição especial",
      "atlético mg edição especial",
      "atletico edição especial",
      "atlético edição especial",
    ],

    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-01-es/galo0.png",
      "/images/brasil/serie-a/atleticomg/25-26-01-es/galo1.png",
      "/images/brasil/serie-a/atleticomg/25-26-01-es/galo2.png",
      "/images/brasil/serie-a/atleticomg/25-26-01-es/galo3.png",
      "/images/brasil/serie-a/atleticomg/25-26-01-es/galo4.png",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme 01 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
      "2025",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-01-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-01-f/galo4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-02/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-02/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-02/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-02/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-02/galo4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme 03",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-03/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-03/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-03/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-03/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-03/galo4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme Black",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "atletico 2025",
      "atlético 2025",
      "2025",
      "atletico mineiro edição especial",
      "atlético mineiro edição especial",
      "atletico mg edição especial",
      "atlético mg edição especial",
      "atletico edição especial",
      "atlético edição especial",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-04/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-04/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-04/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-04/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-04/galo4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Uniforme de Goleiro Preta",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-05/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-05/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-05/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-05/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-05/galo4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Regata de Treino (Amarela)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "regata do atletico",
      "regata do atlético",
      "regata do atletico mineiro",
      "regata do atlético mineiro",
      "regata do atletico",
      "regata do atletico mg",
      "regata do atlético mg",
      "2025",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-06/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-06/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-06/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-06/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-06/galo4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Camisa de Treino (Preta)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-07/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-07/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-07/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-07/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/25-26-07/galo4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 25/26 - Camisa de Treino (Amarela)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/25-26-08/galo0.png",
      "/images/brasil/serie-a/atleticomg/25-26-08/galo1.png",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 24/25 - Uniforme 01",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2025",
      "atlético mineiro 2025",
      "atletico mg 2025",
      "atlético mg 2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/24-25-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01/galo4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 24/25 - Uniforme 01 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2024",
      "atlético mineiro 2024",
      "atletico mg 2024",
      "atlético mg 2024",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
      "2024",
    ],

    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/24-25-01-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-01-f/galo4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 24/25 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2024",
      "atlético mineiro 2024",
      "atletico mg 2024",
      "atlético mg 2024",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/24-25-02/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-02/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-02/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-02/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-02/galo4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 24/25 - Uniforme 03",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2024",
      "atlético mineiro 2024",
      "atletico mg 2024",
      "atlético mg 2024",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/24-25-03/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-03/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-03/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-03/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/24-25-03/galo4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 23/24 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2023",
      "atlético mineiro 2023",
      "atletico mg 2023",
      "atlético mg 2023",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/23-24-02/galo0.jpeg",
      "/images/brasil/serie-a/atleticomg/23-24-02/galo1.jpeg",
      "/images/brasil/serie-a/atleticomg/23-24-02/galo2.jpeg",
      "/images/brasil/serie-a/atleticomg/23-24-02/galo3.jpeg",
      "/images/brasil/serie-a/atleticomg/23-24-02/galo4.jpeg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 22/23 - Uniforme 01",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2022",
      "atlético mineiro 2022",
      "atletico mg 2022",
      "atlético mg 2022",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/22-23-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-01/galo4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 22/23 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2022",
      "atlético mineiro 2022",
      "atletico mg 2022",
      "atlético mg 2022",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/22-23-02/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-02/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-02/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-02/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/22-23-02/galo4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme 01 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
      "2021",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-01-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-01-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-01-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-01-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-01-f/galo4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-02/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-02/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-02/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-02/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-02/galo4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme 03",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-03/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-03/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-03/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-03/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-03/galo4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme de Goleiro (Cinza)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-04/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-04/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-04/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-04/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-04/galo4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme de Goleiro (Laranja)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-05/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-05/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-05/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-05/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-05/galo4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Uniforme de Goleiro (Vermelha)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-06/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-06/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-06/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-06/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-06/galo4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 21/22 - Calção 2",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2021",
      "atlético mineiro 2021",
      "atletico mg 2021",
      "atlético mg 2021",
      "2021",
      "calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/21-22-07/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-07/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-07/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-07/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/21-22-07/galo4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 20/21 - Uniforme 01",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2020",
      "atlético mineiro 2020",
      "atletico mg 2020",
      "atlético mg 2020",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/20-21-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01/galo4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 20/21 - Uniforme 01 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2020",
      "atlético mineiro 2020",
      "atletico mg 2020",
      "atlético mg 2020",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
      "2020",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/20-21-01-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-01-f/galo4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 20/21 - Uniforme 02 (Feminina)",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2020",
      "atlético mineiro 2020",
      "atletico mg 2020",
      "atlético mg 2020",
      "atletico mineiro feminina",
      "atlético mineiro feminina",
      "atletico mg feminina",
      "atlético mg feminina",
      "feminina",
      "2020",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/20-21-02-f/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-02-f/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-02-f/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-02-f/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-02-f/galo4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 20/21 - Uniforme 02",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2020",
      "atlético mineiro 2020",
      "atletico mg 2020",
      "atlético mg 2020",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: ["/images/brasil/serie-a/atleticomg/20-21-02/galo0.jpg"],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 20/21 - Uniforme 03",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2020",
      "atlético mineiro 2020",
      "atletico mg 2020",
      "atlético mg 2020",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/atleticomg/20-21-03/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-03/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-03/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-03/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/20-21-03/galo4.jpg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 16/17 - Uniforme 01 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2016",
      "atlético mineiro 2016",
      "atletico mg 2016",
      "atlético mg 2016",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "2016",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/16-17-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/16-17-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/16-17-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/16-17-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/16-17-01/galo4.jpg",
    ],
  },
  {
    id: 49,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 12/13 - Uniforme 01 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2013",
      "atlético mineiro 2013",
      "atletico mg 2013",
      "atlético mg 2013",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "2013",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/12-13-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/12-13-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/12-13-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/12-13-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/12-13-01/galo4.jpg",
    ],
  },
  {
    id: 50,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 07/08 - Uniforme 01 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2008",
      "atlético mineiro 2008",
      "atletico mg 2008",
      "atlético mg 2008",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "2008",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/07-08-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/07-08-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/07-08-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/07-08-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/07-08-01/galo4.jpg",
    ],
  },
  {
    id: 51,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 02/03 - Uniforme 01 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 2003",
      "atlético mineiro 2003",
      "atletico mg 2003",
      "atlético mg 2003",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "2003",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/02-03-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/02-03-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/02-03-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/02-03-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/02-03-01/galo4.jpg",
    ],
  },
  {
    id: 52,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 95/96 - Uniforme 02 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 1996",
      "atlético mineiro 1996",
      "atletico mg 1996",
      "atlético mg 1996",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "1996",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/95-96-02/galo0.jpeg",
      "/images/brasil/serie-a/atleticomg/95-96-02/galo1.jpeg",
    ],
  },
  {
    id: 53,
    pais: "brasil",
    liga: "serie-a",
    time: "atletico-mg",
    nome: "Atlético Mineiro 94/95 - Uniforme 01 Retrô",
    aliases: [
      "atletico mineiro",
      "atlético mineiro",
      "atletico mg",
      "atlético mg",
      "galo",
      "clube atletico mineiro",
      "cam",
      "galão",
      "atletico",
      "atlético",
      "atletico mineiro 1995",
      "atlético mineiro 1995",
      "atletico mg 1995",
      "atlético mg 1995",
      "retro atletico",
      "retro atlético",
      "retro atletico mineiro",
      "retro atlético mineiro",
      "retro atletico",
      "retro atletico mg",
      "retro atlético mg",
      "atletico retro",
      "atlético retro",
      "atletico mineiro retro",
      "atlético mineiro retro",
      "atletico retro",
      "atletico mg retro",
      "atlético mg retro",
      "1995",
    ],
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/atleticomg/94-95-01/galo0.jpg",
      "/images/brasil/serie-a/atleticomg/94-95-01/galo1.jpg",
      "/images/brasil/serie-a/atleticomg/94-95-01/galo2.jpg",
      "/images/brasil/serie-a/atleticomg/94-95-01/galo3.jpg",
      "/images/brasil/serie-a/atleticomg/94-95-01/galo4.jpg",
    ],
  },
];

export default atleticoMg;
